import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import DemographicFilter from "../../../components/shared/demographicFilter"
import DemographicFilterButton from "../../../components/shared/demographicFilter/demographicFilterButton"
import { loadFilters } from "../../../components/shared/demographicFilter/store/demographicFilter.actions"
import { getDemographicFiltersList } from "../../../components/shared/demographicFilter/store/demographicFilter.selectors"
import flattenFilters from "../../utils/flattenFilters"
import { applyFilters } from "../store/rankings.actions"
import { getActiveFilters } from "../store/rankings.selectors"

const HappiestWorkplacesForYouButton = () => {
  const dispatch = useDispatch()
  const demographicFiltersList = useSelector(getDemographicFiltersList)
  const appliedFilters = useSelector(getActiveFilters)

  const [demographicsFilterIsOpen, setDemographicsFilterIsOpen] = useState(false)

  useEffect(() => {
    dispatch(loadFilters())
  }, [dispatch])

  const isDemographicFiltersSelected =
    Object.values(appliedFilters.demographicFilters)?.length &&
    flattenFilters(Object.values(appliedFilters.demographicFilters))?.length

  const handleSubmit = e => {
    if (e?.awards) {
      dispatch(applyFilters({ award: { id: e.awards.value, name: e.awards.label } }))
      delete e.awards
    }
    if (e?.industry) {
      dispatch(applyFilters({ industry: { id: e.industry.value, name: e.industry.label } }))
      delete e.industry
    }

    if (e?.country) {
      dispatch(applyFilters({ country: { id: e.country.value, name: e.country.label } }))
      delete e.country
    }

    if (Object.keys(e).length) dispatch(applyFilters({ demographicFilters: e }))
  }

  if (!demographicFiltersList) return null

  return (
    <>
      <DemographicFilterButton
        isSelected={isDemographicFiltersSelected}
        onOpen={() => {
          setDemographicsFilterIsOpen(true)
        }}
      />

      {demographicsFilterIsOpen ? (
        <DemographicFilter
          filters={appliedFilters.demographicFilters}
          toggle={setDemographicsFilterIsOpen}
          onApplyFilters={filters => {
            setDemographicsFilterIsOpen(false)
            handleSubmit(filters)
          }}
        />
      ) : null}
    </>
  )
}

export default HappiestWorkplacesForYouButton
